<template>
  <div
    class="set-list-item"
    :class="{'en-set-list-item':isEnglish}"
  >
    <div class="set-list-item-tit">
      <h2>{{ itemData.name }}</h2>
      <i
        class="iconfont "
        :class="isShow ?'iconicon-test18' : 'iconicon-test19'"
        @click="setShowHide"
      />
    </div>
    <div
      v-show="isShow"
      class="set-list-item-list"
    >
      <ul>
        <template v-for="(item2, key) in itemData.child">
          <li
            v-if="item2.state"
            :key="key"
          >
            <span>{{ item2.name }}</span>
            <a
              href="javascript:;"
              @click="setFields(1, item2)"
            >{{ $t('message["235"]') }}</a>
            <a
              href="javascript:;"
              @click="setFields(2, item2)"
            >{{ $t('message["1108"]') }}</a>
          </li>
        </template>
      </ul>
    </div>
    <set-fields-dialog
      ref="setFileds"
      :type="type"
      :config-data="configData"
      :item="item"
      :name="itemData.name"
    />
  </div>
</template>
<script>
import SetFieldsDialog from '../../../components/pc/config/setlist/SetFieldsDialog'
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  components: {
    SetFieldsDialog
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      type: 1,
      configData: {},
      item: {},
      name: '',
      isShow: true
    }
  },
  computed: {
    ...mapState('config/setlist', ['activeMenuData']),
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  methods: {
    ...mapActions('config/setlist', ['getlistfieldsDatas']),
    getLang,
    async setFields (type, item) {
      const { activeMenuData } = this
      const chain = await this.getlistfieldsDatas()
      chain.params({
        roleid: activeMenuData.roleid,
        system_role: activeMenuData.system_role,
        device: type,
        scopestr: item.scopestr
      })
        .onSuccess(raw => {
          this.type = type
          this.item = item
          this.configData = raw
          this.$refs.setFileds.changeVisible(true)
        })
        .fetch()
    },
    setShowHide () {
      this.isShow = !this.isShow
    }
  }
}
</script>
<style lang="scss" scoped>
.set-list-item{
    .set-list-item-tit {
      height: 40px;
      background: #f4f7f9;
      line-height: 40px;
      border-top: 1px solid #ebebeb;
      position: relative;
      padding: 0 12px;
      h2 {
        font-size: 14px;
      }
      i {
        position: absolute;
        right: 12px;
        font-size: 16px;
        color: #d6d6d6;
        top: 0;
        cursor: pointer;
      }
    }
    .set-list-item-list {
      line-height: 24px;
      padding-top: 28px;
      li {
        margin-bottom: 32px;
        padding: 0 12px;
        span {
          color: #666;
          font-size: 14px;
          margin-right: 35px;
          min-width: 120px;
          text-align: left;
          display: inline-block;
        }
        a {
          margin-right: 34px;
        }
      }
    }
  }
  .en-set-list-item {
    .set-list-item-list li span {
      width: 160px !important;
    }
  }
</style>
